//************************************************************************ /
// EVENT CTA CARD
// White card suggesting an action to the user and providing a link to do it.
// Initially themed off the cta-card in the communities package.
//************************************************************************ /

import React from "react";
import Link from "next/link";
import { Card, Button } from "@dreambigger/design-system/src/components";
import { RightOutlined } from "@ant-design/icons";
import InspireAnalytics, {
  InspireAnalyticEvents,
} from "@dreambigger/shared/src/utils/inspire-analytics-helper";
import { useMixpanel, useGA, useSegment } from "@dreambigger/shared/src/hooks";

type eventDetailCta = {
  ctaAction: string;
  ctaTitle: string;
  title: string;
};

const EventCtaCard = (eventDetailCta: eventDetailCta) => {
  // Load Analytics
  const mixpanel = useMixpanel();
  const segment = useSegment();
  const googleAnalytics = useGA();

  //Do not display card if lacking essential information
  if (
    !eventDetailCta.ctaAction ||
    !eventDetailCta.ctaTitle ||
    !eventDetailCta.title
  ) {
    return <></>;
  }
  // Destructure data and render.
  const { ctaAction, ctaTitle, title } = eventDetailCta;

  const handleClick = () => {
    // Track analytics of button click
    googleAnalytics.event({
      category: "Event Detail Page",
      action: `CTA Click - Card ${window.location.href}`,
      label: `${ctaTitle} - ${ctaAction}`,
      value: 1,
    });
    InspireAnalytics.track({
      eventName: InspireAnalyticEvents.CTA_CLICK,
      properties: {
        "CTA Type": "Learn about the journey",
      },
      mixpanel,
      segment,
    });
  };

  return (
    <Card
      style={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        backgroundColor: "white",
      }}
      bodyStyle={{ padding: "26px 26px" }}
    >
      <div className="flex flex-column items-center">
        {/* Call To Action Text */}
        <h4 className="tl fwb f-5 mb-5 lh-3">{title}</h4>
        {/* Button Link */}
        <a
          href={ctaAction}
          className="flex w-100"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Button
            className={`primary b-primary ttu primaryBkdWhiteTxt h-7 w-100`}
            style={{ border: "solid 2px", transition: "0.1s" }}
            onClick={handleClick}
          >
            <RightOutlined className="vh" /> <span>{ctaTitle}</span>{" "}
            <RightOutlined />
          </Button>
        </a>
      </div>
    </Card>
  );
};

export default EventCtaCard;
